export default __webpack_public_path__ + "maps-examples-restrict-coordinate-bounds-thumbnail-960-5372599ffb44e2d53d69e101e74c8c2b.webp";